// components/crm/CRMManagement.jsx
import React, { useState, useEffect } from 'react';
import { PAGE_META, usePageMeta } from '../../lib/pageMeta';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import LeadsManagement from './LeadsManagement';
import TasksManagement from './TasksManagement';
import CRMAnalytics from './CRMAnalytics';
import { api } from '../../lib/api';

export default function CRMManagement() {
  usePageMeta(PAGE_META.crm);
  const [activeTab, setActiveTab] = useState('leads');
  const [stats, setStats] = useState(null);
  const [taskStats, setTaskStats] = useState(null);

  const fetchStats = async () => {
    try {
      const [leadsStats, tasksStats] = await Promise.all([
        api.get('/leads/stats/overview'),
        api.get('/tasks/stats/overview'),
      ]);
      setStats(leadsStats.data.data);
      setTaskStats(tasksStats.data.data);
    } catch (error) {
      console.error('Error fetching CRM stats:', error);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const handleDataUpdate = () => {
    fetchStats();
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">CRM Management</h1>
          <p className="text-gray-600">Manage leads, tasks, and customer relationships</p>
        </div>
      </div>

      {/* Main Content Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-3 max-w-lg">
          <TabsTrigger value="leads">Leads</TabsTrigger>
          <TabsTrigger value="tasks">Tasks</TabsTrigger>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
        </TabsList>

        <TabsContent value="leads" className="space-y-4">
          <LeadsManagement onDataUpdate={handleDataUpdate} />
        </TabsContent>

        <TabsContent value="tasks" className="space-y-4">
          <TasksManagement onDataUpdate={handleDataUpdate} />
        </TabsContent>

        <TabsContent value="analytics" className="space-y-4 pt-2">
          <CRMAnalytics stats={stats} taskStats={taskStats} />
        </TabsContent>
      </Tabs>
    </div>
  );
}